import { ReactNode } from 'react'

interface AuthLayoutProps {
  children: ReactNode
}

export function AuthCardLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4 antialiased font-inter">
      {children}
    </div>
  )
}